// extracted by mini-css-extract-plugin
module.exports = {"commonContainer":"reset_commonContainer__q252-","formContainer":"reset_formContainer__262Gx","buttonContainer":"reset_buttonContainer__3arYv"};